import type { Theme } from "@mui/material/styles";
import { white } from "../../themes/sbux/color-palettes";

const styles = (theme: Theme) => ({
  root: {
    height: "calc(74vh)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  dataGridRoot: {
    "& .MuiDataGrid-iconSeparator": {
      // visibility: "hidden",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "15px !important",
      color: white.neutral,
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontSize: "15px !important",
    },
    width: "100%",
    height: "100% !important",
    boxSizing: "border-box",
    border: "0 !important",
    paddingTop: "5px",
    // Hide native browser scrollbar — MUI DataGrid v7 renders its own custom overlay scrollbar
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    // Style MUI DataGrid's custom overlay scrollbar
    "& .MuiDataGrid-scrollbar": {
      "&.MuiDataGrid-scrollbar--vertical": {
        width: "6px",
      },
      "&.MuiDataGrid-scrollbar--horizontal": {
        height: "6px",
      },
      "& .MuiDataGrid-scrollbarContent": {
        borderRadius: "4px",
        backgroundColor: theme.palette.primary.main,
      },
    },
    // Prevent pagination/footer from creating an outer scrollbar
    "& .MuiTablePagination-root": {
      overflow: "visible",
      maxHeight: "none",
      flex: "0 0 auto",
      flexGrow: 0,
      alignItems: "center",
      backgroundColor: "transparent",
      minWidth: 0,
    },
    "& .MuiTablePagination-toolbar": {
      alignItems: "center",
      paddingTop: 0,
    },
    "& .MuiTablePagination-select": {
      fontSize: 13,
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 13,
      margin: 0,
      alignSelf: "center",
    },
    "& .MuiTablePagination-input": {
      alignSelf: "center",
      margin: 0,
      marginRight: 16,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 13,
      margin: 0,
      alignSelf: "center",
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
      overflow: "visible",
      backgroundColor: theme.palette.darkGray[200],
    },
    "& .MuiDataGrid-bottomContainer": {
      overflow: "visible",
      borderTop: "0 !important",
      borderBottom: "0 !important",
    },
  },
  sbuxLogo: {
    height: 120,
    width: 120,
    maxWidth: 120,
    maxHeight: 120,
    [theme.breakpoints.down("md")]: {
      height: "auto",
      width: "auto",
    },
  },
  overlayContent: {
    top: 10,
    fontSize: 20,
    fontWeight: 600,
  },
  gridToolbar: {
    display: "flex",
    flexWrap: "nowrap",
    width: "100%",
    alignItems: "center",
    padding: "8px 0",

    "& .MuiButton-root": {
      width: "auto",
      whiteSpace: "nowrap",
      flexShrink: 0,
    },

    "& .MuiTextField-root": {
      width: "150px",
      minWidth: "150px",
      maxWidth: "150px",
      flexShrink: 0,
    },

    "& > *:not(button)": {
      flex: "0 1 auto",
    },

    "& > .MuiFormControl-root": {
      flexDirection: "row",
      alignItems: "center",
      flex: "1 1 1500px",
      maxWidth: "300px",
      "& > .MuiFormLabel-root": {
        display: "flex",
        alignItems: "center",
        whiteSpace: "break-spaces",
        lineHeight: "1.23em",
        paddingLeft: theme.spacing(1),
      },
      "& > .MuiFormControl-fullWidth": {
        [theme.breakpoints.up("lg")]: {
          maxWidth: "40%",
        },
        [theme.breakpoints.down("md")]: {
          width: "auto",
        },
      },
    },
  },
});

export default styles;
